export default __webpack_public_path__ + "static/media/account.4f774a6a.svg";